import { render, staticRenderFns } from "./step-bar.vue?vue&type=template&id=811913f4&scoped=true"
import script from "./step-bar.vue?vue&type=script&lang=js"
export * from "./step-bar.vue?vue&type=script&lang=js"
import style0 from "./step-bar.vue?vue&type=style&index=0&id=811913f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811913f4",
  null
  
)

export default component.exports